import { GovernorAmountThresholdDetails } from '@components/governor-amount-threshold-details/governor-amount-threshold-details';

export const GovernorAmountThresholdDetailsWidget = () => <GovernorAmountThresholdDetails />;
